module.exports = __webpack_public_path__ + "static/media/vn.b615833a.webp";